import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpertDeliveryRulesSchema } from 'src/app/models/expert-delivery-rules.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { ExpertDeliveryRulesService } from 'src/app/services/expert-delivery-rules.service';

@Component({
  selector: 'app-expert-delivery-rules',
  templateUrl: './expert-delivery-rules.component.html',
  styleUrls: ['./expert-delivery-rules.component.scss']
})
export class ExpertDeliveryRulesComponent implements OnInit {

  filtered = {};
  limit: number;
  page: number;
  count: number;
  maxPage: number;
  order: {};
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'ExpertDeliveryRules.createdAt': 'DESC' };
  expertDeliveryRules: any[] = [];
  expertDeliveryRulesFilterForm: any;
  activeAccordionActivityIndex: number | null = null;
  showingExpertDeliveryRule: ExpertDeliveryRulesSchema;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
    private expertDeliveryRulesService: ExpertDeliveryRulesService,
  ) { 
    this.managepartnerExpertRulesFilterForm();
  }

  async ngOnInit() {
    await this.filter();
  }

  async managepartnerExpertRulesFilterForm(){
    this.expertDeliveryRulesFilterForm = new FormGroup({
      'ExpertDeliveryRules.id': new FormControl(''),
      'ExpertDeliveryRules.pickUps': new FormControl(''),
      'ExpertDeliveryRules.pickUps.operator': new FormControl('equal'),
      'ExpertDeliveryRules.plusSalary': new FormControl(''),
      'ExpertDeliveryRules.plusSalary.operator': new FormControl('equal'),
      'UserExpert.surname': new FormControl(''),
    });
  }

  async loadExpertDeliveryRules(limit?: number, page?: number, order?: {}){
    try {
      this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
      this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
      this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
      let expertDeliveryRules = await this.expertDeliveryRulesService.getAll(this.page, this.limit, this.order, this.filtered);
      this.expertDeliveryRules = expertDeliveryRules;
      this.count = expertDeliveryRules.length;
      this.maxPage = Math.ceil(this.count / this.limit);
    } catch (error) {
      console.log("Error", error);
    }
  }

  formatTimeShow(fromTime, toTime){
    let trimmedFromTime = fromTime != null ? fromTime?.slice(0, -3) : '';
    let trimmedToTime = toTime != null ? toTime?.slice(0, -3) : '';
    let time = trimmedFromTime + '-' + trimmedToTime;
    return time;
  }

  async filter(){
    let filterForm = (new FormGroupToObject()).transform(this.expertDeliveryRulesFilterForm);
    this.filtered = {};

    if (filterForm['ExpertDeliveryRules.id'])
      this.filtered['ExpertDeliveryRules.id'] = filterForm['ExpertDeliveryRules.id'];  
    if (filterForm['UserExpert.surname'])
      this.filtered['UserExpert.surname'] = { operator: 'like', values: [`%${filterForm['UserExpert.surname']}%`], concat: [{ string: ' ' }, { column: 'UserExpert.name' }] };
    if (filterForm['ExpertDeliveryRules.pickUps'])
      this.filtered['ExpertDeliveryRules.pickUps'] = { operator: filterForm['ExpertDeliveryRules.pickUps.operator'], values: [filterForm['ExpertDeliveryRules.pickUps']] };
    if (filterForm['ExpertDeliveryRules.plusSalary'])
      this.filtered['ExpertDeliveryRules.plusSalary'] = { operator: filterForm['ExpertDeliveryRules.plusSalary.operator'], values: [filterForm['ExpertDeliveryRules.plusSalary']] };

    this.loadExpertDeliveryRules();

  }

  async delete(id: number){
    if (!confirm("Sei sicuro di voler eliminare questa regola di consegna del valet?"))
      return;
    try { 
      const result = await this.expertDeliveryRulesService.delete(id);
      await this.showSnackBar('Regola di consegna valet eliminata correttamente');
      await this.loadExpertDeliveryRules();
    } catch (error) {
      this.showSnackBar(`${error.error.message}`);
    }
  }

  async resetFilter() {
    await this.managepartnerExpertRulesFilterForm();
    await this.filter();
  }

  async navigate(event) {
    await this.loadExpertDeliveryRules(event.limit, event.page, this.order);
  }

  public async navigateOrder(attribute: string | string[]) {
    delete this.order['FlowersSales.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    await this.navigatePage(this.limit, this.page, { order: this.order });
  }

  async navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.loadExpertDeliveryRules();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }
  
  async showSnackBar(message: string) {
    this._snackBar.open(`${message}`, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    })
  }

  toggleAccordion(index?: number){
    if (this.activeAccordionActivityIndex === index) {
      this.activeAccordionActivityIndex = null;
    } else {
      this.activeAccordionActivityIndex = index; 
    }
    this.showingExpertDeliveryRule = this.expertDeliveryRules[index];
  }

  getRules(expertDeliveryRule: ExpertDeliveryRulesSchema){
    return expertDeliveryRule.rules && typeof expertDeliveryRule.rules === 'string' ? JSON.parse(expertDeliveryRule.rules) : []; 
  }

}
